export const TICKET_TASK_FILTERS = {
  TICKET_CATEGORIES: [
    {
      label: "- Select -",
      value: "",
    },
    {
      label: "Information",
      value: "INFORMATION",
      dayCount: 1,
    },
    {
      label: "Enhancement",
      value: "ENHANCEMENT",
      dayCount: 0,
    },
    {
      label: "Issue",
      value: "ISSUE",
      dayCount: 1,
    },
    {
      label: "Task",
      value: "TASK",
      dayCount: 3,
    },

    {
      label: "Complete",
      value: "COMPLETE",
      dayCount: 2,
    },

    {
      label: "Tech Minor",
      value: "T_MINOR",
      dayCount: 3,
      color: "rgb(189, 215, 238)",
    },
    {
      label: "Tech Major",
      value: "T_MAJOR",
      dayCount: 2,
      color: "rgb(189, 215, 238)",
    },
    {
      label: "Tech Urgent",
      value: "T_URGENT",
      dayCount: 1,
      color: "rgb(189, 215, 238)",
    },
    {
      label: "Billing Minor",
      value: "B_MINOR",
      dayCount: 3,
      color: "rgb(198, 224, 180)",
    },
    {
      label: "Billing Major",
      value: "B_MAJOR",
      dayCount: 2,
      color: "rgb(198, 224, 180)",
    },
    {
      label: "Billing Urgent",
      value: "B_URGENT",
      dayCount: 1,
      color: "rgb(198, 224, 180)",
    },

    {
      label: "Clinical Minor",
      value: "C_MINOR",
      dayCount: 3,
      color: "rgb(248, 203, 173)",
    },
    {
      label: "Clinical Major",
      value: "C_MAJOR",
      dayCount: 2,
      color: "rgb(248, 203, 173)",
    },
    {
      label: "Clinical Urgent",
      value: "C_URGENT",
      dayCount: 1,
      color: "rgb(248, 203, 173)",
    },

    {
      label: "EDI Minor",
      value: "E_MINOR",
      dayCount: 3,
      color: "rgb(204, 255, 102)",
    },
    {
      label: "EDI Major",
      value: "E_MAJOR",
      dayCount: 2,
      color: "rgb(204, 255, 102)",
    },
    {
      label: "EDI Urgent",
      value: "E_URGENT",
      dayCount: 1,
      color: "rgb(204, 255, 102)",
    },

    {
      label: "PEHR Dev Minor",
      value: "PEHR_MINOR",
      dayCount: 5,
      color: "rgb(146, 205, 220)",
    },
    // {
    //   label: "EDI Major",
    //   value: "MAJOR",
    //   dayCount: 2,
    //   color: "rgb(204, 255, 102)",
    // },
    {
      label: "PEHR Dev Major",
      value: "PEHR_MAJOR",
      dayCount: 3,
      color: "rgb(146, 205, 220)",
    },
    {
      label: "PEHR Dev Urgent",
      value: "PEHR_URGENT",
      dayCount: 1,
      color: "rgb(146, 205, 220)",
    },
    {
      label: "DB Minor",
      value: "DB_MINOR",
      dayCount: 5,
      color: "rgb(250, 191, 143)",
    },
    {
      label: "DB Major",
      value: "DB_MAJOR",
      dayCount: 3,
      color: "rgb(250, 191, 143)",
    },
    {
      label: "DB Urgent",
      value: "DB_URGENT",
      dayCount: 1,
      color: "rgb(250, 191, 143)",
    },

    {
      label: "EPM Dev Minor",
      value: "EPM_MINOR",
      dayCount: 5,
      color: "rgb(177, 160, 199)",
    },
    {
      label: "EPM Dev Major",
      value: "EPM_MAJOR",
      dayCount: 3,
      color: "rgb(177, 160, 199)",
    },
    {
      label: "EPM Dev Urgent",
      value: "EPM_URGENT",
      dayCount: 1,
      color: "rgb(177, 160, 199)",
    },

    {
      label: "IT Minor",
      value: "IT_MINOR",
      dayCount: 5,
      color: "rgb(196, 215, 155)",
    },
    {
      label: "IT Major",
      value: "IT _MAJOR",
      dayCount: 3,
      color: "rgb(196, 215, 155)",
    },
    {
      label: "IT Urgent",
      value: "IT_URGENT",
      dayCount: 1,
      color: "rgb(196, 215, 155)",
    },

    {
      label: "QA Minor",
      value: "QA_MINOR",
      dayCount: 3,
      color: "rgb(232, 184, 242)",
    },
    {
      label: "QA Major",
      value: "QA_MAJOR",
      dayCount: 2,
      color: "rgb(232, 184, 242)",
    },
  ],

  PRODUCTS: [
    {
      label: "Practice EHR",
      value: "EHR",
    },
    {
      label: "Practice EHR PM",
      value: "PM",
    },
    {
      label: "Practice EHR EPM",
      value: "EPM",
    },
    {
      label: "EDI",
      value: "EDI",
    },
  ],

  TYPES: [
    {
      label: "-Select-",
      value: "",
    },
    {
      label: "Training",
      value: "T",
    },
    {
      label: "Internal",
      value: "I",
    },
    {
      label: "Recurring",
      value: "R",
    },
  ],
  STATUS_DATA: [
    {
      label: "Open",
      value: "O",
      check: false,
    },
    {
      label: "In Progress",
      value: "I",
      check: false,
    },
    {
      label: "Pending On Client",
      value: "Q",
      check: false,
    },
    {
      label: "Resolved",
      value: "R",
      check: false,
    },
    {
      label: "Reopened",
      value: "K",
      check: false,
    },
  ],

  SOURCES: [
    {
      label: "Phone Call",
      value: "P",
    },
    {
      label: "Support",
      value: "S",
    },
    {
      label: "Email",
      value: "E",
    },
  ],

  VIEW_ABLES: [
    {
      label: "All",
      value: "A",
    },
    {
      label: "Internal Only",
      value: "I",
    },
  ],
  STATUS_DAYS_OPTIONS: [
    {
      label: "Select",
      value: "",
    },
    {
      label: "1 day",
      value: "1",
    },
    {
      label: "2 days",
      value: "2",
    },

    {
      label: "3 days",
      value: "3",
    },
    {
      label: "5 days",
      value: "5",
    },

    {
      label: "7 days",
      value: "7",
    },
    {
      label: "10 days",
      value: "10",
    },

    {
      label: "15 days",
      value: "15",
    },

    {
      label: "20 days",
      value: "20",
    },
    {
      label: "1 month",
      value: "30",
    },
    {
      label: "6 months",
      value: "180",
    },

    {
      label: "1 year",
      value: "365",
    },

    {
      label: "All years",
      value: "8000",
    },
  ],
  STATUS_ALL: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Created",
      value: "C",
    },
    {
      label: "In Progress",
      value: "I",
    },
    {
      label: "Pending",
      value: "P",
    },
    {
      label: "Pending on client",
      value: "Q",
    },
    {
      label: "Today's Deadline",
      value: "TD",
    },
    {
      label: "Tickets Overdue",
      value: "OD",
    },
    {
      label: "Overdue",
      value: "O",
    },
    {
      label: "Follow up",
      value: "FU",
    },
    {
      label: "Completed",
      value: "R",
    },
  ],
  STATUS_TASKS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Created",
      value: "C",
    },
    {
      label: "Pending",
      value: "P",
    },
    {
      label: "Pending on client",
      value: "Q",
    },

    {
      label: "Today's Deadline",
      value: "TD",
    },
    {
      label: "Ticket Overdue",
      value: "OD",
    },

    {
      label: "Overdue",
      value: "O",
    },
    {
      label: "Follow up",
      value: "FU",
    },
    {
      label: "Completed",
      value: "R",
    },
  ],
  STATUS_TICKETS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Open",
      value: "O",
    },
    {
      label: "Created",
      value: "C",
    },
    {
      label: "In Progress",
      value: "I",
    },
    {
      label: "Pending on client",
      value: "Q",
    },

    {
      label: "Today's Deadline",
      value: "TD",
    },
    {
      label: "Ticket Overdue",
      value: "OD",
    },
    {
      label: "Follow up",
      value: "FU",
    },
    {
      label: "Resolved",
      value: "R",
    },
  ],
  CATEGORY_OPTIONS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Support",
      value: "Support",
    },
    {
      label: "Implementation",
      value: "Implementation",
    },
    {
      label: "Clinical",
      value: "Clinical",
    },
    {
      label: "Technical Support",
      value: "Technical Support",
    },
    {
      label: "Account and Billing Support",
      value: "Account and Billing Support",
    },
  ],
  PRIORITY_OPTIONS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Low",
      value: "Low",
    },
    {
      label: "Medium",
      value: "Medium",
    },
    {
      label: "High",
      value: "High",
    },
    {
      label: "Critical",
      value: "Critical",
    },
  ],
  PRIORITY_CLIENTS_OPTIONS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Urgent",
      value: "Y",
    },
    {
      label: "Normal",
      value: "N",
    },
  ],
  SUSPENDED_OPTIONS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Yes",
      value: "Y",
    },
    {
      label: "No",
      value: "N",
    },
  ],
  FILTER_TYPES: [
    {
      label: "All",
      value: "A",
    },
    {
      label: "Tickets",
      value: "Ticket",
    },
    {
      label: "Tasks",
      value: "Task",
    },
  ],
};
